export const AccountDetailsTabAeMessages = () => {
  return <div>AE Messages tab</div>;
};
